import React from "react";
import RateMatrix from "./rateMatrix";
import CriteriaMatrix from "./criteriaMatrix";
import { baseTheme } from "mui-theme";
import {
  AppBar,
  Tabs,
  Tab,
  ThemeProvider,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import { YieldApi } from "../../../../api/yield";
import { format } from "date-fns";
import Popup from "../../../../reusable-components/popup/popup";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface State {
  isOpen: boolean;
  isloading: boolean;
  selectedIndex: number;
  value: number;
}
export interface IMatrixModalProps {
  hotel: any;
}

export default class MatrixModal extends React.Component<IMatrixModalProps> {
  hotel: any;

  handleChange = (event: any, newValue: number) => {
    if (this.state.value == 0) {
      this.tempMatrix.criteria =
        this.criteriaMatrixRef.current.exportCriterias();
    } else {
      this.tempMatrix.rateMatrixes =
        this.rateMatrixRef.current.exportRateMatrixes();
    }
    this.setState({ value: newValue });
  };

  state: State = {
    isOpen: true,
    isloading: false,
    selectedIndex: 0,
    value: 0,
  };
  tempMatrix: any = {};
  private criteriaMatrixRef = React.createRef<any>();
  private rateMatrixRef = React.createRef<any>();

  constructor(props: any) {
    super(props);
    this.state.isOpen = false;
    this.hotel = props.hotel;
    //this.changePeriod = this.changePeriod.bind(this)
    this.handleChange = this.handleChange.bind(this);
    this.save = this.save.bind(this);
    this.close = this.close.bind(this);
  }

  async open(dayDate: string) {
    this.setState({
      isOpen: true,
      dayDate: dayDate,
      selectedIndex: 0,
    });
  }

  save() {
    if (this.state.value == 0) {
      this.tempMatrix.criteria =
        this.criteriaMatrixRef.current.exportCriterias();
    } else {
      this.tempMatrix.rateMatrixes =
        this.rateMatrixRef.current.exportRateMatrixes();
    }
    let clonedMatrixes = JSON.parse(
      JSON.stringify(this.hotel.suggestionParams.matrixes),
    );
    let res: any[] = [];

    let rateMatrixes = this.tempMatrix.rateMatrixes;
    if (!rateMatrixes) {
      rateMatrixes = clonedMatrixes;
    }
    let i = 0;
    for (let item of rateMatrixes) {
      res[i] = {
        start:
          typeof item.start == "undefined"
            ? format(new Date(), "yyyy-MM-dd")
            : item.start,
        end:
          typeof item.end == "undefined"
            ? format(new Date(), "yyyy-MM-dd")
            : item.end,
        bands: item.bands,
      };
      i++;
    }
    let criteria = this.tempMatrix.criteria;
    if (criteria) {
      //change in criteria (or not!)
      let i = 0;
      for (let item of rateMatrixes) {
        let j = 0;
        for (let band of criteria) {
          if (res[i].bands[j]) {
            res[i].bands[j].criterias = criteria[j];
          } else {
            if (criteria[j]) {
              //new band
              res[i].bands[j] = {
                criterias: criteria[j],
                formula: "[999,999,999,999,999,999,999][dow]",
              };
            }
          }
          j++;
        }
        let l = res[i].bands.length;
        if (l > criteria.length) {
          let nToRemove = l - criteria.length;
          res[i].bands = res[i].bands.slice(0, nToRemove * -1);
        }
        i++;
      }
    }
    this.setState({ isLoading: true });
    YieldApi.writeSuggestionParams({
      hotelId: this.hotel.hotelId,
      suggestionParams: { matrixes: res },
    })
      .then(() => {
        this.setState({ isLoading: false });
        window.location.reload(); // you can pass true to reload function to ignore the client cache and reload from the server
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  }
  close() {
    this.setState({ isOpen: false });
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevState.isOpen !== this.state.isOpen) {
      if (this.state.isOpen) {
        document.body.style.overflow = "hidden"; // Apply CSS property when popup is open
      } else {
        document.body.style.overflow = ""; // Reset CSS property when popup is closed
      }
    }
  }

  render() {
    const content = [
      <React.Fragment key="matrix-content">
        {this.state.isloading ? (
          <Backdrop open={this.state.isloading}>
            <CircularProgress color="inherit" id="circular-progress" />
          </Backdrop>
        ) : (
          <ThemeProvider theme={baseTheme}>
            <AppBar position="static">
              <Tabs
                value={this.state.value}
                onChange={this.handleChange}
                aria-label="simple tabs example"
              >
                <Tab label="Rate band Definition" {...a11yProps(0)} />
                <Tab label="Rate Matrixes" {...a11yProps(1)} />
              </Tabs>
            </AppBar>
            <TabPanel value={this.state.value} index={0}>
              <div style={{ padding: 0 }}>
                <div style={{ height: 10 }}></div>
                <CriteriaMatrix
                  ref={this.criteriaMatrixRef}
                  {...{
                    hotel: this.hotel,
                  }}
                />
              </div>
            </TabPanel>
            <TabPanel value={this.state.value} index={1}>
              <div>
                <RateMatrix
                  ref={this.rateMatrixRef}
                  {...{
                    hotel: this.hotel,
                    index: 0,
                  }}
                />
              </div>
            </TabPanel>
          </ThemeProvider>
        )}
      </React.Fragment>,
    ];

    return (
      <Popup
        isPopupOpen={this.state.isOpen}
        title="Rate Matrix Configuration"
        content={content}
        action={this.save}
        actionName="Save"
        cancelAction={this.close}
        cancelName="Cancel"
        closeOnOutsideClick={true}
        maxWidth="lg"
      ></Popup>
    );
  }
}
